import React from "react";
import GenericLayout from "layouts/generic";
import ContactSection from "sections/contact";

export default function ContactPage() {
  return <GenericLayout
    title="Contact Us | Deviate Labs"
    description="Contact and work with Deviate Labs."
    color="yellow"
  >
    <ContactSection/>
  </GenericLayout>;
}

